"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.ExpandedTableContext = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const ExpandedTableContext = react_1.createContext({ tableExpandable: false, expandedDefault: false });
exports.ExpandedTableContext = ExpandedTableContext;
const Table = (props) => {
    const tableClasses = classnames_1.default({
        [props.className]: props.className,
        'table': true,
        'table-compact': props.compact,
        'table-expandable': props.expandable,
        'table-fixed': props.fixed === true,
        'table-read-only': props.readOnly === true,
        'table-sorting': props.sortable,
    });
    return (React.createElement("table", { ref: props.forwardRef, className: tableClasses },
        React.createElement(ExpandedTableContext.Provider, { value: {
                expandedDefault: !!props.defaultExpanded,
                tableExpandable: !!props.expandable,
            } }, props.children)));
};
exports.Table = Table;
//# sourceMappingURL=Table.js.map